import { useEffect } from "react";
import { useTheme } from "./useTheme";

/**
 * Pins the document to light theme for the lifetime of the calling component.
 *
 * The admin areas (/admin, /util-admin) are light-only by design — they have no
 * theme toggle and were only ever rendered dark via the OS `prefers-color-scheme`
 * fallback. Calling this from the admin route guards forces `data-theme="light"`
 * (covering portaled dropdowns/toasts too, since it sets it on <html>). The
 * customer portal keeps its own preference; on unmount the override is cleared so
 * the user's chosen theme is restored.
 */
export const useForceLightTheme = (): void => {
	const { setOverrideMode } = useTheme();

	useEffect(() => {
		setOverrideMode("light");
		return () => setOverrideMode(null);
	}, [setOverrideMode]);
};
